import styled, { css } from 'styled-components';
import { FunctionColor } from '@lux/core';
export const SvgIcon = styled.svg.withConfig({ displayName: "SvgIcon", componentId: "sc-1sexdd6" }) `fill:${({ color }) => color};display:inline-block;vertical-align:middle;${(p) => p.useStroke && css `stroke:${() => p.stroke || p.color};`}`;
SvgIcon.defaultProps = {
    color: FunctionColor.function100,
    width: '16px',
    height: '16px',
    stroke: null,
    useStroke: false,
    role: 'img',
    'aria-hidden': true,
    focusable: 'false', // fix for ie
};
export default SvgIcon;
//# sourceMappingURL=component.js.map